import styled from "styled-components";

export const Subheader = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 400;
`;
